import React, { useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Modal,
  IconButton,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";

import StatusModal from "../../../../Global_Component/CustomConfirmStatusModal";
import {
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";

const sampleData = [
    {
        id: 1,
        phoneNumber: "4021236521",
        name: "Beef Bar",
        coaProvider: "SK Laboratories",
        managerName: "Maqsood Ahmad",
        bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
      },
      {
        id: 2,
        phoneNumber: "5029874652",
        name: "Green Valley Dairy",
        coaProvider: "Nature Labs",
        managerName: "Zeeshan Ali",
        bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
      },
      {
        id: 3,
        phoneNumber: "3087641239",
        name: "Spice Treat",
        coaProvider: "Herbal Blend Labs",
        managerName: "Aisha Khan",
        bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
      },
      {
        id: 4,
        phoneNumber: "4159872134",
        name: "Healthy Harvest",
        coaProvider: "Nutri Labs",
        managerName: "Fahad Ansari",
        bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
      },
      {
        id: 5,
        phoneNumber: "6239874521",
        name: "Pure Bakes",
        coaProvider: "Organic Essentials",
        managerName: "Sara Malik",
        bill: "https://res.cloudinary.com/dkdpj2rq0/raw/upload/v1736218721/wqckm0dczxy4dw8wmmfr",
      },
];

const CoaPage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [status, setStatus] = useState(false);
  const [selectedBill, setSelectedBill] = useState("");

  const handleOpenModal = (bill) => {
    setSelectedBill(bill);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedBill("");
  };

  return (
    <Box sx={{ padding: "16px" }}>
        <StatusModal open={status} onClose={e=>setStatus(false)}/>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Typography variant="h5" sx={{ fontWeight: "600" }}>
          COA (certificate of Analysis)
        </Typography>
        <Box>
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            sx={{ textTransform: "none", mr: 1 }}
          >
            Download
          </Button>
          <Button
            variant="outlined"
            startIcon={<EditIcon />}
            sx={{ textTransform: "none" }}
          >
            Edit
          </Button>
        </Box>
      </Grid>

      <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFC" }}>
              <TableCell sx={{ fontWeight: "500" }}>SL No.</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>
                COA Product Name
              </TableCell>
              <TableCell sx={{ fontWeight: "500" }}>COA Certificate Provider</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Manage of Lab</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Number Of Lab manger</TableCell>
              
              <TableCell sx={{ fontWeight: "500" }}>Certifcate Upload</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sampleData.map((item, index) => (
              <TableRow key={item.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.name}</TableCell>
                <TableCell>{item.coaProvider}</TableCell>
                <TableCell>{item.mangerName}</TableCell>
                <TableCell>{item.phoneNumber}</TableCell>
              
                <TableCell>
                  <Button
                    sx={{ textTransform: "none", color: "blue" }}
                    onClick={() => handleOpenModal(item.bill)}
                  >
                    View Bill
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* PDF Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="bill-modal-title"
        aria-describedby="bill-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            height: "90vh",
            p: 4,
          }}
        >
          <Box
            display="flex"
            justifyContent="end"
            alignItems="center"
            sx={{ my: 1 }}
          >
            <IconButton onClick={handleCloseModal}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Example Document Content */}
          <Box
            component="iframe"
            src={`https://docs.google.com/viewer?url=${selectedBill}&embedded=true`}
            sx={{
              width: "100%",
              height: "90%",
              border: "none", // Removes the iframe border
              margin: 0,
              padding: 0,
              display: "block", // Ensures there are no inline gaps
            }}
          />
        </Box>
      </Modal>

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <CustomSecondaryButton label={"Back"} />
        <CustomSuccessButton label={"Approved"} onClick={e=>setStatus(true)} />
      </Grid>
    </Box>
  );
};

export default CoaPage;
